<template>
    <tbody>
        <item-summary 
            ref="itemSummary"
            :document-name="internalDocument.name"
            @toggle-details="showDetails = !showDetails" 
        ></item-summary>

        <item-detail 
            v-if="showDetails"
            ref="itemDetail"
            :index="index"
            :customer-id="customerId"
            :internal-document-id="internalDocument.id"
            @file-uploaded="onFileUploaded($event)"
            @file-deleted="onFileDeleted($event)"
            @last-file-deleted="onLastFileDeleted($event)"
        ></item-detail>
    </tbody>
</template>

<script type="text/babel">
import ItemSummary from './ItemSummary'
import ItemDetail from './ItemDetail'

export default {
    name:"DocumentItem",
    
    props: {
        index: {
            type: Number,
            required: true
        },
        customerId: {
            type: Number,
            required: true
        },
        internalDocument: {
            type: Object,
            required: true
        }
    },
    
    data () {
        return {
            showDetails: false
        }
    },

    components: {
        ItemSummary,
        ItemDetail
    },

    computed: {},

    methods: {
        onFileUploaded(index) {
            this.$emit('file-uploaded', index)
        },
        onFileDeleted(index) {
            this.$emit('file-deleted', index)
        },
        onLastFileDeleted(index) {
            this.$emit('last-file-deleted', index)
        }
    }
}
</script>

<style lang="scss" scoped>
    tbody + tbody {
        border-top: inherit;
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InternalDocuments/Item.vue